import React, { FC } from 'react';

import styled from 'styled-components';

import aampeTheme from '../../../../../../constants/aampeTheme';

interface AttributePlaceholderDataViewProps {
    headerName: string;
    defaultValue?: string;
    attributeName?: string;
}
const AttributePlaceholderDataView: FC<AttributePlaceholderDataViewProps> = ({
    headerName,
    defaultValue,
    attributeName,
}) => {
    return (
        <Container>
            <HeaderText>{headerName}</HeaderText>
            <Content>
                <span>{attributeName}</span>
                <span> default value : {defaultValue}</span>
            </Content>
        </Container>
    );
};

const Container = styled.div({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    borderLeft: `1px solid ${aampeTheme.colors.interactiveWG01}`,
});

const HeaderText = styled.div({
    display: 'flex',
    padding: aampeTheme.spacing4(2, 4),
    fontSize: aampeTheme.size.font.textMedium,
    lineHeight: aampeTheme.size.lineHeight.default,
    fontWeight: aampeTheme.weights.medium,
    border: `1px solid ${aampeTheme.colors.interactiveWG01}`,
    borderTop: '0px',
    borderRight: '0px',
    color: aampeTheme.colors.textAccessibleWG01,
    height: '88px',
    backgroundColor: aampeTheme.colors.backgroundWG02,
    borderLeft: '0px',
    minWidth: '220px',
});

const Content = styled.div({
    display: 'flex',
    flexDirection: 'column',
    padding: aampeTheme.spacing4(2, 4),
    fontSize: aampeTheme.size.font.default,
    lineHeight: aampeTheme.size.lineHeight.default,
    fontWeight: aampeTheme.weights.light,
    border: `1px solid ${aampeTheme.colors.interactiveWG01}`,
    borderTop: '0px',
    borderRight: '0px',
    color: aampeTheme.colors.neutral09,
    minHeight: '45px',
    borderLeft: '0px',
    gap: aampeTheme.spacing4(1),
    minWidth: '220px',
});
export default AttributePlaceholderDataView;
